module.exports = require("./nyn-UG.js");